import React from 'react';
import styled from 'styled-components';
import { htractionAIFlow } from 'src/assets/images';
import { useNavigate } from 'react-router';

const Flowchart: React.FC = () => {
  const navigate = useNavigate();
    const handleInternalRedirect = () => {
      navigate('/login');
    };
    
  return (
    <Container>

      <div>
      <Title>Investors Don’t Guess. They Score.</Title>
      <SubTitle>So Should You</SubTitle>
      <Description>
        Get a holistic investor grade score on your startup’s readiness across 7 critical investment metrics.
      </Description>
      <GetStartedButton onClick={handleInternalRedirect}>Get Started</GetStartedButton>
      </div>
      <FlowchartImage src={htractionAIFlow} alt="Htraction AI Flowchart"/>
    </Container>
  );
};

const Container = styled.section`
  padding: 100px 80px;
  background-color: #fafafa;;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 80px 40px;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  @media (max-width: 480px) {
    padding: 40px 20px;
  }

`;

const Title = styled.h2`
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 10px;
  
`;

const Description = styled.p`
  font-size: 16px;
  color: #666;
  max-width: 400px;
`;

const SubTitle = styled.h3`
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 16px;
  background: linear-gradient(90deg, #FF5733, #FF8C00);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const GetStartedButton = styled.button`
  background: linear-gradient(90deg, #FF5733, #FF8C00);
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #E63D1A;
  }
`;

const FlowchartImage = styled.img`
  max-width: 550px;
  margin-left: 20px;
  object-fit: contain;

  /* Tablet styles */
  @media (max-width: 768px) {
    max-width: 100%;
    margin-left: 0;
    margin-top: 30px;
  }

  /* Mobile styles */
  @media (max-width: 480px) {
    margin-top: 20px;
  }
`;
export default Flowchart;
